import styled from 'styled-components/macro';
import { Radio } from '@material-ui/core';

export const RadioMI = styled(Radio)`
  padding-right: 4px;
`